module.exports = __webpack_public_path__ + "static/img/Cortnee-Vine.0fbd03b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cortnee-Vine.jpg
// module id = Z/DS
// module chunks = 0